import { updateMatch } from "./matchService";
import { addRawFitnessData } from "./fitnessDataSync/fitnessDataSyncService";
import { FitnessDataType } from "refsix-js-models";

const SCORZA_EXAMPLE_RESULT_URL =
    "https://assets.scorza.com/app-content/example-result.json";

async function fetchExampleResult() {
    const response = await fetch(SCORZA_EXAMPLE_RESULT_URL);

    if (!response.ok) {
        throw new Error(
            `Failed to fetch example result: ${response.status} ${response.statusText}`
        );
    }

    return await response.json();
}

export async function insertExampleResult(username: string) {
    try {
        const data = await fetchExampleResult();
        if (data) {
            data.match.date = new Date().toISOString();
            const gps = {
                ...data.gps,
                data: data.gps.geoPoints,
                geoPoints: null,
            };
            const hr = {
                ...data.hr,
                data: data.hr.heartRateValues,
                heartRateValues: null,
            };

            // No need to unit test these 3 functions, since they are already being tested elsewhere.
            await updateMatch(data.match);
            await addRawFitnessData(gps, username, FitnessDataType.GPS);
            await addRawFitnessData(hr, username, FitnessDataType.HeartRate);
        }
    } catch (error) {
        return Promise.reject(error);
    }
}
